/**
 * Lo que abre una cuenta que es SÓLO courier de Lima (20260925169000).
 *
 * El founder, 25-sep: «el courier sólo ve sus pedidos asignados». Su trabajo es entregar y cobrar:
 * ve sus pedidos (por su parte, la base ya le muestra sólo esos), su liquidación, su perfil con sus
 * motorizados, y sus ajustes. Sin productos, catálogo, clientes ni «crear venta»: no vende.
 *
 * 🪤 ESTO ORDENA EL MENÚ, NO PROTEGE DATOS: lo que un courier puede leer lo decide la base (RLS por
 *    participación). Un menú más corto es para que no se pierda, no para que no pueda.
 */
import { matchPath } from 'react-router-dom';
import { ROUTES } from '@/config/routes.config';
import { rutaSinTienda } from './rutasDelRolDrop';

export const RUTAS_DEL_ROL_COURIER: readonly string[] = [
  ROUTES.HOME,
  // Todas las notificaciones (20-oct-2026): la campana muestra las últimas 20 y su pie lleva acá.
  ROUTES.NOTIFICACIONES,
  /*
   * ⭐ SUS PEDIDOS, EN ENTREGAS Y NO EN VENTAS (20261021004300). El founder, 20-oct: «no es bueno que el courier entre
   *    a ver la lista de ventas, sino que de frente vaya a entregas»; y ve sólo lo que el almacén ya preparó. De ahí
   *    abre la venta para registrar la entrega.
   */
  ROUTES.ENTREGAS_POR_RECOGER, ROUTES.ENTREGAS_LIQUIDACIONES, ROUTES.OPS_ORDER_DETAIL, ROUTES.OPS_ORDER_ENTREGA,
  // Su plata y su perfil (motorizados, invitaciones).
  ROUTES.DROPSHIPPING_SMARTYDROP_LIQUIDACION,
  ROUTES.DROPSHIPPING_SMARTYDROP_COURIERS,
  // Sus zonas y su mapa: las páginas de Transporte de siempre (20260925184000).
  ROUTES.TRANSPORT_MOTORIZADOS, ROUTES.TRANSPORT_MOTOR_COURIER_DETAIL,
  // Ajustes: su negocio y su gente.
  ROUTES.SETTINGS, ROUTES.SETTINGS_GENERAL, ROUTES.SETTINGS_BUSINESS,
  ROUTES.SETTINGS_USERS, ROUTES.SETTINGS_USERS_ROLES, ROUTES.SETTINGS_USERS_SECURITY,
  ROUTES.SETTINGS_PLAN,
];

/** ¿Puede una cuenta que es sólo courier abrir esta URL? */
export function laRutaEsDelRolCourier(pathname: string): boolean {
  const ruta = rutaSinTienda(pathname);
  return RUTAS_DEL_ROL_COURIER.some((patron) => matchPath({ path: patron, end: true }, ruta) !== null);
}
